// components/share/shareChrome.ts — styled primitives shared by the share sheets.
//
// Separate from ShareSheetParts.tsx purely so that file exports COMPONENTS ONLY
// (react-refresh/only-export-components cannot tell a styled-component from a
// plain constant, and a mixed file costs Fast Refresh on every edit).

import styled from 'styled-components';

export const ShareSrOnly = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`;

export const ShareSectionLabel = styled.p`
  margin: 0 0 8px;
  font-family: ${({ theme }) => theme.font.body};
  font-size: ${({ theme }) => theme.fontSize.sm};
  font-weight: 500;
  color: ${({ theme }) => theme.color.textMuted};
`;

export const ShareTileGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(72px, 1fr));
  gap: 8px;
`;
